// Which browser is this? Only what a feature has to know, read off the user
// agent string so it can be tested without a browser. Firefox on iPhone/iPad
// ("FxiOS") is Safari's engine underneath, so it does not count as Firefox.
export function isFirefox(ua = (typeof navigator !== "undefined" ? navigator.userAgent : "")) {
  return /\bFirefox\/\d/.test(ua || "")
}

// The major version, e.g. 146 — null when it isn't Firefox.
export function firefoxVersion(ua = (typeof navigator !== "undefined" ? navigator.userAgent : "")) {
  const m = /\bFirefox\/(\d+)/.exec(ua || "")
  return m ? parseInt(m[1], 10) : null
}
